import angular from 'angular';

import ChangePasswordController from './changePassword/changePasswordController';
import ChangePasswordService from './changePassword/changePasswordFactory';
import EmailDirective from './email/emailDirective';
import PasswordDirective from './password/passwordDirective';

export default angular.module('app.common.controls', [])
    .controller('ChangePasswordController', ChangePasswordController)
    .service('ChangePasswordService', ChangePasswordService)
    .directive('hpEmailInput', EmailDirective)
    .run(($templateCache) => {
        $templateCache.put('app/common/controls/changePassword/changePassword.html', require('./changePassword/changePassword.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/controls/email/emailTemplate.html', require('./email/emailTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/controls/password/passwordTemplate.html', require('./password/passwordTemplate.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/common/controls/index.js